import React from 'react';
import InputMask from 'react-input-mask';
import { UserCircleIcon, PhoneIcon } from '@heroicons/react/24/outline';
import { TWInput, FieldLabel } from '../../../components/ui';

const Owner = ({ responsiblename, responsiblephone, onChange, errors }) => {
  const handleChange = (value, key) => {
    onChange(value, key);
  };

  return (
    <div className="grid grid-cols-1 gap-3 sm:gap-5">
      <TWInput
        label="Owner / Manager name"
        labelIcon={UserCircleIcon}
        size="lg"
        required
        placeholder="Jane Doe"
        value={responsiblename}
        onChange={(e) => handleChange(e.target.value, 'responsiblename')}
        error={
          errors.responsiblename ? 'Enter your owner/manager name' : undefined
        }
      />

      <div>
        <FieldLabel icon={PhoneIcon} required>
          Owner / Manager phone
        </FieldLabel>
        <InputMask
          id="responsiblephone"
          mask="(999) 999 9999"
          maskPlaceholder=" "
          name="responsiblephone"
          value={responsiblephone}
          onChange={(e) => handleChange(e.target.value, 'responsiblephone')}
          style={{ letterSpacing: '0.15rem' }}
          className={
            'block h-11 w-full rounded-md border bg-white px-3 text-base text-slate-900 placeholder-slate-400 transition focus:outline-none focus:ring-1 dark:bg-slate-900 dark:text-slate-100 dark:placeholder-slate-500 ' +
            (errors.responsiblephone
              ? 'border-rose-400 focus:border-rose-500 focus:ring-rose-500 dark:border-rose-500/70'
              : 'border-slate-200 focus:border-blue-500 focus:ring-blue-500 dark:border-slate-600 dark:focus:border-sky-400 dark:focus:ring-sky-400')
          }
        />
        {errors.responsiblephone ? (
          <p className="mt-1 text-xs text-rose-600 dark:text-rose-400">
            Please enter a valid phone number.
          </p>
        ) : (
          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Only for account-related contact.
          </p>
        )}
      </div>
    </div>
  );
};

export default Owner;
